import React, { Fragment } from "react";
import bg from "../../assets/image/04.jpg";

import img1 from "../../assets/image/course-01.jpg";
import img2 from "../../assets/image/course-02.jpg";
import img3 from "../../assets/image/course-03.jpg";
import img4 from "../../assets/image/course-04.jpg";
import img5 from "../../assets/image/course_8.jpg";
import img6 from "../../assets/image/course_7.jpg";
import img7 from "../../assets/image/course_9.jpg";
import img8 from "../../assets/image/gallery_5.jpg";
import img9 from "../../assets/image/course_3.jpg";
import img10 from "../../assets/image/course_1.jpg";
import img11 from "../../assets/image/05.jpg";

import BreadBanner from "../../component/BreadBanner";
const BlogItems = () => {
  return (
    <Fragment>
      <BreadBanner bg={bg} title={"Single Blog"} />
      <div className="blogItem">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="blogItem_content">
                <div className="blogItem_title">
                  ‘I Kept Thinking of Antioch’: Long Before #MeToo, a times
                  Video Journalist Remembered
                </div>
                <div className="blogItem_meta">
                  <ul>
                    <li>
                      Post on <a href="#">May 5, 2018</a>
                    </li>
                    <li>
                      By <a href="#">admin</a>
                    </li>
                  </ul>
                </div>
                <div className="blogItem_image">
                  <img src={img11} alt="" />
                </div>
                <p>
                  Times Insider delivers behind-the-scenes insights into how
                  news, features and opinion come together at The New York
                  Times.Before I could spend the night in my younger sister’s
                  dorm room at Antioch College in Yellow Springs, Ohio — before
                  I could read the spines of her textbooks or drink a disgusting
                  but lovingly prepared vodka/sparkling wine/Red Bull — I had to
                  report to security:
                </p>
                <div className="blogItem_quote d-flex flex-row align-items-center justify-content-start">
                  <i className="fa fa-quote-left" aria-hidden="true"></i>
                  <div>
                    “All sexual interactions at Antioch College must be
                    consensual. Consent means verbally asking and verbally
                    giving or denying consent.”
                  </div>
                </div>
                <p>
                  It was 2004, a decade before the phrase “affirmative consent”
                  made it onto news shows or big university campuses. I was 21,
                  a junior at another college. I think it was the first time I
                  had heard people talk about consent as something you could ask
                  for verbally. It was definitely the first time I’d ever seen
                  it written out like that.
                </p>
                <p>
                  The first-of-its-kind affirmative consent policy was written
                  by students in 1990 as a response to campus rape. But the
                  first thing anyone who was at Antioch in the ’90s wanted to
                  talk to me about was the media mayhem. When The Associated
                  Press ran an article on the policy with the headline “No
                  huggy, no kissy without a ‘yes’ at Antioch College,” it
                  ignited a cultural firestorm.
                </p>
                <div className="blogItem_subtitle">
                  All the current students
                </div>
                <p>
                  I followed up with for the video told me that being sexual
                  with an Antioch student is different from being sexual with
                  someone else. They spoke of a common language everyone is
                  taught beginning at orientation, so that when one student
                  starts asking questions of another student in the midst of
                  sexual activity, it doesn’t seem so out there.
                </p>
                <div className="blogItem_images">
                  <div className="row">
                    <div className="col-lg-6 blogItem_images_col">
                      <div className="blogItem_image_small">
                        <img src={img1} alt="" />
                      </div>
                    </div>
                    <div className="col-lg-6 blogItem_images_col">
                      <div className="blogItem_image_small">
                        <img src={img2} alt="" />
                      </div>
                    </div>
                  </div>
                </div>
                <p>
                  But what is it like to be an 18-year-old and have the
                  expectation set that you will talk during sex? I, for one,
                  have never been part of a community with that expectation.
                  Spending time at Antioch’s orientation, I thought about how
                  that might change your sexual interactions for the rest of
                  your life.
                </p>
              </div>
              <div className="blogItem_extra d-flex flex-lg-row flex-column align-items-lg-center align-items-start justify-content-start">
                <div className="blogItem_tags">
                  <span>Tags: </span>
                  <ul>
                    <li>
                      <a href="#">Education</a>,{" "}
                    </li>
                    <li>
                      <a href="#">Math</a>,{" "}
                    </li>
                    <li>
                      <a href="#">Food</a>,{" "}
                    </li>
                    <li>
                      <a href="#">Schools</a>,{" "}
                    </li>
                    <li>
                      <a href="#">Religion</a>,{" "}
                    </li>
                  </ul>
                </div>
                <div className="blogItem_social ml-lg-auto">
                  <span>Share: </span>
                  <ul>
                    <li>
                      <a href="#">
                        <i className="fa fa-facebook" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa fa-twitter" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa fa-google-plus" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa fa-linkedin" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa fa-envelope" aria-hidden="true"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="comments_container">
                <div className="comments_title">
                  <span>30</span> Comments
                </div>
                <ul className="comments_list">
                  <li>
                    <div className="comment_item d-flex flex-row align-items-start jutify-content-start">
                      <div className="comment_image">
                        <div>
                          <img src={img3} alt="" />
                        </div>
                      </div>
                      <div className="comment_content">
                        <div className="comment_title_container d-flex flex-row align-items-center justify-content-start">
                          <div className="comment_author">
                            <a href="#">Jennifer Aniston</a>
                          </div>
                          <div className="comment_rating">
                            <div className="rating_r rating_r_4">
                              <i></i>
                              <i></i>
                              <i></i>
                              <i></i>
                              <i></i>
                            </div>
                          </div>
                          <div className="comment_time ml-auto">
                            October 19,2018
                          </div>
                        </div>
                        <div className="comment_text">
                          <p>
                            There are many variations of passages of Lorem Ipsum
                            available, but the majority have alteration in some
                            form, by injected humour.
                          </p>
                        </div>
                        <div className="comment_extras d-flex flex-row align-items-center justify-content-start">
                          <div className="comment_extra comment_likes">
                            <a href="#">
                              <i
                                className="fa fa-thumbs-up"
                                aria-hidden="true"
                              ></i>
                              <span>108</span>
                            </a>
                          </div>
                          <div className="comment_extra comment_reply">
                            <a href="#">
                              <i
                                className="fa fa-pencil-square-o"
                                aria-hidden="true"
                              ></i>
                              <span>Reply</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ul>
                      <li>
                        <div className="comment_item d-flex flex-row align-items-start jutify-content-start">
                          <div className="comment_image">
                            <div>
                              <img src={img4} alt="" />
                            </div>
                          </div>
                          <div className="comment_content">
                            <div className="comment_title_container d-flex flex-row align-items-center justify-content-start">
                              <div className="comment_author">
                                <a href="#">John Smith</a>
                              </div>
                              <div className="comment_rating">
                                <div className="rating_r rating_r_4">
                                  <i></i>
                                  <i></i>
                                  <i></i>
                                  <i></i>
                                  <i></i>
                                </div>
                              </div>
                              <div className="comment_time ml-auto">
                                October 19,2018
                              </div>
                            </div>
                            <div className="comment_text">
                              <p>
                                There are many variations of passages of Lorem
                                Ipsum available, but the majority have
                                alteration in some form, by injected humour.
                              </p>
                            </div>
                            <div className="comment_extras d-flex flex-row align-items-center justify-content-start">
                              <div className="comment_extra comment_likes">
                                <a href="#">
                                  <i
                                    className="fa fa-thumbs-up"
                                    aria-hidden="true"
                                  ></i>
                                  <span>108</span>
                                </a>
                              </div>
                              <div className="comment_extra comment_reply">
                                <a href="#">
                                  <i
                                    className="fa fa-pencil-square-o"
                                    aria-hidden="true"
                                  ></i>
                                  <span>Reply</span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <div className="comment_item d-flex flex-row align-items-start jutify-content-start">
                      <div className="comment_image">
                        <div>
                          <img src={img5} alt="" />
                        </div>
                      </div>
                      <div className="comment_content">
                        <div className="comment_title_container d-flex flex-row align-items-center justify-content-start">
                          <div className="comment_author">
                            <a href="#">Jane Austen</a>
                          </div>
                          <div className="comment_rating">
                            <div className="rating_r rating_r_4">
                              <i></i>
                              <i></i>
                              <i></i>
                              <i></i>
                              <i></i>
                            </div>
                          </div>
                          <div className="comment_time ml-auto">
                            October 19,2018
                          </div>
                        </div>
                        <div className="comment_text">
                          <p>
                            There are many variations of passages of Lorem Ipsum
                            available, but the majority have alteration in some
                            form, by injected humour.
                          </p>
                        </div>
                        <div className="comment_extras d-flex flex-row align-items-center justify-content-start">
                          <div className="comment_extra comment_likes">
                            <a href="#">
                              <i
                                className="fa fa-thumbs-up"
                                aria-hidden="true"
                              ></i>
                              <span>108</span>
                            </a>
                          </div>
                          <div className="comment_extra comment_reply">
                            <a href="#">
                              <i
                                className="fa fa-pencil-square-o"
                                aria-hidden="true"
                              ></i>
                              <span>Reply</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
                <div className="add_comment_container">
                  <div className="add_comment_title">Write a comment</div>
                  <div className="add_comment_text">
                    Your email address will not be published. Required fields
                    are marked *
                  </div>
                  <form action="#" className="comment_form">
                    <div>
                      <div className="form_title">Review*</div>
                      <textarea
                        className="comment_input comment_textarea"
                        required="required"
                      ></textarea>
                    </div>
                    <div className="row">
                      <div className="col-md-6 input_col">
                        <div className="form_title">Name*</div>
                        <input
                          type="text"
                          className="comment_input"
                          required="required"
                        />
                      </div>
                      <div className="col-md-6 input_col">
                        <div className="form_title">Email*</div>
                        <input
                          type="text"
                          className="comment_input"
                          required="required"
                        />
                      </div>
                    </div>
                    <div className="comment_notify">
                      <input
                        type="checkbox"
                        id="checkbox_notify"
                        name="regular_checkbox"
                        className="regular_checkbox checkbox_account"
                        checked
                      />
                      <label for="checkbox_notify">
                        <i className="fa fa-check" aria-hidden="true"></i>
                      </label>
                      <span>Notify me of new posts by email</span>
                    </div>
                    <div>
                      <button
                        type="submit"
                        className="comment_button trans_200"
                      >
                        submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="sidebar">
                <div className="sidebar_section">
                  <div className="sidebar_section_title">Categories</div>
                  <div className="sidebar_categories">
                    <ul className="categories_list">
                      <li>
                        <a href="#" className="clearfix">
                          Art & Design<span>(25)</span>
                        </a>
                      </li>
                      <li>
                        <a href="#" className="clearfix">
                          Business<span>(10)</span>
                        </a>
                      </li>
                      <li>
                        <a href="#" className="clearfix">
                          IT & Software<span>(22)</span>
                        </a>
                      </li>
                      <li>
                        <a href="#" className="clearfix">
                          Languages<span>(12)</span>
                        </a>
                      </li>
                      <li>
                        <a href="#" className="clearfix">
                          Programming<span>(18)</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="sidebar_section">
                  <div className="sidebar_section_title">Latest Courses</div>
                  <div className="sidebar_latest">
                    <div className="latest d-flex flex-row align-items-start justify-content-start">
                      <div className="latest_image">
                        <div>
                          <img src={img6} alt="" />
                        </div>
                      </div>
                      <div className="latest_content">
                        <div className="latest_title">
                          <a href="course.html">
                            How to Design a Logo a Beginners Course
                          </a>
                        </div>
                        <div className="latest_date">november 11, 2017</div>
                      </div>
                    </div>

                    <div className="latest d-flex flex-row align-items-start justify-content-start">
                      <div className="latest_image">
                        <div>
                          <img src={img7} alt="" />
                        </div>
                      </div>
                      <div className="latest_content">
                        <div className="latest_title">
                          <a href="course.html">
                            Photography for Beginners MasterclassName
                          </a>
                        </div>
                        <div className="latest_date">november 11, 2017</div>
                      </div>
                    </div>

                    <div className="latest d-flex flex-row align-items-start justify-content-start">
                      <div className="latest_image">
                        <div>
                          <img src={img8} alt="" />
                        </div>
                      </div>
                      <div className="latest_content">
                        <div className="latest_title">
                          <a href="course.html">The Secrets of Body Language</a>
                        </div>
                        <div className="latest_date">november 11, 2017</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="sidebar_section">
                  <div className="sidebar_section_title">Instagram</div>
                  <div className="sidebar_gallery">
                    <ul className="gallery_items d-flex flex-row align-items-start justify-content-between flex-wrap">
                      <li className="gallery_item">
                        <img src={img9} alt="" />
                      </li>
                      <li className="gallery_item">
                        <img src={img10} alt="" />
                      </li>
                      <li className="gallery_item">
                        <img src={img4} alt="" />
                      </li>
                      <li className="gallery_item">
                        <img src={img8} alt="" />
                      </li>
                      <li className="gallery_item">
                        <img src={img4} alt="" />
                      </li>
                      <li className="gallery_item">
                        <img src={img2} alt="" />
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="sidebar_section">
                  <div className="sidebar_section_title">Tags</div>
                  <div className="sidebar_tags">
                    <ul className="tags_list">
                      <li>
                        <a href="#">creative</a>
                      </li>
                      <li>
                        <a href="#">unique</a>
                      </li>
                      <li>
                        <a href="#">photography</a>
                      </li>
                      <li>
                        <a href="#">ideas</a>
                      </li>
                      <li>
                        <a href="#">wordpress</a>
                      </li>
                      <li>
                        <a href="#">startup</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default BlogItems;
